import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.CLASS_UNIT = function (state, payload) {
  state.class_unit = payload
}
mutations.CLASS_STUDENTS = function (state, payload) {
  state.class_students = payload
}
mutations.Branch_List = function (state, payload) {
  state.branch = payload
}

const state = {
  rows: [],
  row: null,
  condition: {},
  branch: [],
  class_unit: [],
  class_students: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        class_unit: {api: 'M0401ClassService.getClassNameForSelectBox'},
        branch: {api: 'M0101BranchService.findBranchForListBox'}
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('CLASS_UNIT', data.class_unit.output)
        commit('Branch_List', data.branch.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0405ClassUnitAttendant cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0405ClassUnitAttendant search')
    return client.postData({ data: { search: { api: 'M0404ClassUnitService.searchByClassID', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0405ClassUnitAttendant add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0405ClassUnitAttendant edit')
    return client.postData({ data: { find: { api: 'M0405ClassUnitAttendantService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0405ClassUnitAttendant delete')
    return client.postData({ data: { delete: { api: 'M0405ClassUnitAttendantService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0405ClassUnitAttendant save')
    return client.postData({ data: { save: { api: 'M0405ClassUnitAttendantService.saveDataDetails', input: row } } })
      .then((data) => {
        alert('Save Successful!')
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0405ClassUnitAttendant download')
    return client.download({ data: { download: { api: 'M0405ClassUnitAttendantService.downloadData', input: condition } } })
  },
  getStudentList: ({ commit, state }, condition) => {
    console.debug('called M0405ClassUnitAttendant getStudentList')
    return client.postData({ data: { class_student: { api: 'M0403ClassStudentService.getStudentsFromClass', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.class_student.output)) {
          alert('no match reccord')
        }
        commit('CLASS_STUDENTS', data.class_student.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0405ClassUnitAttendant/M0405ClassUnitAttendantStore.js